import * as TYPES from './_types';

//Reducer
const INITIAL_STATE = {
  data: [],
  page: 1,
  total_pages: 1,
  total: 0,
  search: '',
  sort_by: 'email',
  sort_order: 'desc'
};

export default function users(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TYPES.FETCH_USERS:
      const { search, sort_by, sort_order } = action.payload;

      return {
        ...state,
        sort_by,
        sort_order,
        search
      };

    case TYPES.FETCH_USERS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        total_pages: action.payload.total_pages,
        page: action.payload.page
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/views/users/_reducer.js